/** Integrations → Webhooks: where a webhook receives leads from, and its masked URL (PREC-4253). */
export const enWebhookLists = {
	column: "Lists",
	listInactive: "List inactive",
	privateLists_one: "{{count}} private list of a colleague",
	privateLists_other: "{{count}} private lists of colleagues",
	showMore: "+ {{count}} more",
	showLess: "Show less",
	triggerUnknown: "Sends leads",
	notAttached: "Not attached to any list",
	notAttachedHint:
		'It will not receive leads automatically. Turn it on in a list\'s settings under "{{place}}".',
	url: {
		label: "Webhook URL",
		maskedHint: "The URL's secret parts are hidden.",
		replace: "Replace URL",
		replaceHintAfter: "to enter a new one; leaving it keeps the stored URL.",
		replaceHint: "Paste the full URL, including its secret.",
		keepCurrent: "Keep current URL",
	},
	/** The body the webhook receives (PREC-4251). */
	payloadVersion: {
		label: "Payload format",
		v2: "Version 2: one event per lead",
		v2Hint:
			"Each delivery is an object with the event type, a delivery id, the time and the list, with the lead under data.",
		v1: "Version 1: list of leads (legacy)",
		v1Hint: "The array webhooks have always received. Keep it for integrations built on it.",
	},
};
